export const FacebookIcon = ({ fill }) => {
  return (
    <a
      aria-label="Facebook"
      href="https://www.facebook.com/ElMedioDeMedios"
      target="_blank"
      rel="noreferrer noopener"
      className="hover:scale-110 transform transition-transform duration-300"
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 0H33.75C35.8211 0 37.5 1.67893 37.5 3.75V33.75C37.5 35.8211 35.8211 37.5 33.75 37.5H3.75C1.67893 37.5 0 35.8211 0 33.75V3.75C0 1.67893 1.67893 0 3.75 0ZM3.75 3.75V33.75H33.75V3.75H3.75ZM17.1243 18.7582H20.6248V30H24.3748V18.7582H28.0918V15.0082H24.3748V13.125C24.3748 12.0895 25.2143 11.25 26.2498 11.25H28.1248V7.5H26.2498C23.1432 7.5 20.6248 10.0184 20.6248 13.125V15.0082H17.1243V18.7582Z"
          fill={fill}
        />
      </svg>
    </a>
  );
};

export const InstagramIcon = ({ fill }) => {
  return (
    <a
      aria-label="Instagram"
      href="https://www.instagram.com/elmediodemedios/"
      target="_blank"
      rel="noreferrer noopener"
      className="hover:scale-110 transform transition-transform duration-300"
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27 0.75H12C5.7868 0.75 0.75 5.7868 0.75 12V27C0.75 33.2132 5.7868 38.25 12 38.25H27C33.2132 38.25 38.25 33.2132 38.25 27V12C38.25 5.7868 33.2132 0.75 27 0.75ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5H27C31.1421 4.5 34.5 7.85786 34.5 12V27C34.5 31.1421 31.1421 34.5 27 34.5H12C7.85786 34.5 4.5 31.1421 4.5 27V12ZM19.5 28.875C14.3223 28.875 10.125 24.6777 10.125 19.5C10.125 14.3223 14.3223 10.125 19.5 10.125C24.6777 10.125 28.875 14.3223 28.875 19.5C28.875 24.6777 24.6777 28.875 19.5 28.875ZM19.5 25.125C22.6066 25.125 25.125 22.6066 25.125 19.5C25.125 16.3934 22.6066 13.875 19.5 13.875C16.3934 13.875 13.875 16.3934 13.875 19.5C13.875 22.6066 16.3934 25.125 19.5 25.125ZM30.75 10.125C30.75 11.1605 29.9105 12 28.875 12C27.8395 12 27 11.1605 27 10.125C27 9.08947 27.8395 8.25 28.875 8.25C29.9105 8.25 30.75 9.08947 30.75 10.125Z"
          fill={fill}
        />
      </svg>
    </a>
  );
};

export const TwitterIcon = ({ fill }) => {
  return (
    <a
      aria-label="Twitter"
      href="https://x.com/elmediodemedios"
      target="_blank"
      rel="noreferrer noopener"
      className="hover:scale-110 transform transition-transform duration-300"
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1L14.6124 20.847L1.47758 36H5.40074L16.344 23.3763L25.0019 36H25.8048H37L23.0448 15.646L35.7401 1.00001H31.817L21.3132 13.1196L13.001 1.00001L1 1ZM6.60788 3.91667H11.3954L31.3951 33.0833H26.6076L6.60788 3.91667Z"
          fill={fill}
        />
        <path
          d="M1 1L1 0.5L0.0507613 0.499999L0.587665 1.28281L1 1ZM14.6124 20.847L14.9903 21.1745L15.2432 20.8827L15.0248 20.5642L14.6124 20.847ZM1.47758 36L1.09976 35.6725L0.382474 36.5H1.47758V36ZM5.40074 36V36.5H5.62902L5.77855 36.3275L5.40074 36ZM16.344 23.3763L16.7564 23.0935L16.3902 22.5597L15.9662 23.0488L16.344 23.3763ZM25.0019 36L24.5896 36.2828L24.7386 36.5H25.0019V36ZM37 36V36.5H37.949L37.4124 35.7173L37 36ZM23.0448 15.646L22.667 15.3185L22.414 15.6103L22.6324 15.9287L23.0448 15.646ZM35.7401 1.00001L36.118 1.32751L36.8352 0.500015L35.7401 0.500015V1.00001ZM31.817 1.00001V0.500015H31.5887L31.4391 0.672546L31.817 1.00001ZM21.3132 13.1196L20.9009 13.4024L21.267 13.9363L21.691 13.447L21.3132 13.1196ZM13.001 1.00001L13.4133 0.717212L13.2644 0.500015L13.001 0.500015L13.001 1.00001ZM6.60788 3.91667V3.41667H5.65877L6.19551 4.19943L6.60788 3.91667ZM11.3954 3.91667L11.8078 3.6339L11.6588 3.41667H11.3954V3.91667ZM31.3951 33.0833V33.5833H32.3442L31.8074 32.8006L31.3951 33.0833ZM26.6076 33.0833L26.1952 33.3661L26.3442 33.5833H26.6076V33.0833ZM0.587665 1.28281L14.2001 21.1298L15.0248 20.5642L1.41233 0.717192L0.587665 1.28281ZM14.2346 20.5195L1.09976 35.6725L1.8554 36.3275L14.9903 21.1745L14.2346 20.5195ZM1.47758 36.5H5.40074V35.5H1.47758V36.5ZM5.77855 36.3275L16.7218 23.7038L15.9662 23.0488L5.02294 35.6725L5.77855 36.3275ZM15.9317 23.6591L24.5896 36.2828L25.4143 35.7172L16.7564 23.0935L15.9317 23.6591ZM25.0019 36.5H25.8048V35.5H25.0019V36.5ZM25.8048 36.5H37V35.5H25.8048V36.5ZM37.4124 35.7173L23.4571 15.3633L22.6324 15.9287L36.5876 36.2827L37.4124 35.7173ZM23.4226 15.9735L36.118 1.32751L35.3623 0.672517L22.667 15.3185L23.4226 15.9735ZM35.7401 0.500015H31.817V1.50001H35.7401V0.500015ZM31.4391 0.672546L20.9353 12.7921L21.691 13.447L32.1948 1.32748L31.4391 0.672546ZM21.7255 12.8368L13.4133 0.717212L12.5886 1.28282L20.9009 13.4024L21.7255 12.8368ZM13.001 0.500015L1 0.5L0.999999 1.5L13.001 1.50001L13.001 0.500015ZM6.60788 4.41667H11.3954V3.41667H6.60788V4.41667ZM10.983 4.19943L30.9827 33.3661L31.8074 32.8006L11.8078 3.6339L10.983 4.19943ZM31.3951 32.5833H26.6076V33.5833H31.3951V32.5833ZM27.0199 32.8006L7.02024 3.6339L6.19551 4.19943L26.1952 33.3661L27.0199 32.8006Z"
          fill="black"
        />
      </svg>
    </a>
  );
};

export const LinkedinIcon = ({ fill }) => {
  return (
    <a
      aria-label="Linkedin"
      href="https://www.linkedin.com/company/medio-de-medios/"
      target="_blank"
      rel="noreferrer noopener"
      className="hover:scale-110 transform transition-transform duration-300"
    >
      <svg
        width="46"
        height="45"
        viewBox="0 0 46 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 3.75H38C40.0711 3.75 41.75 5.42893 41.75 7.5V37.5C41.75 39.5711 40.0711 41.25 38 41.25H8C5.92893 41.25 4.25 39.5711 4.25 37.5V7.5C4.25 5.42893 5.92893 3.75 8 3.75ZM8 7.5V37.5H38V7.5H8ZM24.875 16.875C23.9042 16.875 22.8786 17.1717 21.9728 17.7228L21.125 16.875H19.25V30H23V22.5C23 21.4205 24.1137 20.625 24.875 20.625H26.75C27.5113 20.625 28.625 21.4205 28.625 22.5V30H32.375V22.5C32.375 19.026 29.3637 16.875 26.75 16.875H24.875ZM15.5 15C16.5355 15 17.375 14.1605 17.375 13.125C17.375 12.0895 16.5355 11.25 15.5 11.25C14.4645 11.25 13.625 12.0895 13.625 13.125C13.625 14.1605 14.4645 15 15.5 15ZM13.625 16.875V30H17.375V16.875H13.625Z"
          fill={fill}
        />
      </svg>
    </a>
  );
};
